/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Roadmap_IntroInputs */

const en_us2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote for what you want to see first. The team reads every vote and decides the order; nothing here has a date.`)
};

const pt_br2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote no que você quer ver primeiro. A equipe lê todos os votos e decide a ordem; nada aqui tem data marcada.`)
};

const es_419_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota por lo que quieres ver primero. El equipo lee todos los votos y decide el orden; nada aquí tiene fecha.`)
};

const pt_pt2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota no que queres ver primeiro. A equipa lê todos os votos e decide a ordem; nada aqui tem data marcada.`)
};

const fr_fr2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote pour ce que tu veux voir en premier. L'équipe lit chaque vote et décide de l'ordre ; rien ici n'a de date.`)
};

const de_de2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimm ab, was du zuerst sehen willst. Das Team liest jede Stimme und entscheidet über die Reihenfolge; nichts hier hat ein Datum.`)
};

const it_it2_community_roadmap_intro = /** @type {(inputs: Community_Roadmap_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota cosa vuoi vedere per primo. Il team legge ogni voto e decide l'ordine; niente qui ha una data.`)
};

/**
* | output |
* | --- |
* | "Vote for what you want to see first. The team reads every vote and decides the order; nothing here has a date." |
*
* @param {Community_Roadmap_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_roadmap_intro = /** @type {((inputs?: Community_Roadmap_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Roadmap_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_roadmap_intro(inputs)
	if (locale === "es-419") return es_419_community_roadmap_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_community_roadmap_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_community_roadmap_intro(inputs)
	if (locale === "de-DE") return de_de2_community_roadmap_intro(inputs)
	if (locale === "it-IT") return it_it2_community_roadmap_intro(inputs)
	return en_us2_community_roadmap_intro(inputs)
});
export { community_roadmap_intro as "community.roadmap_intro" }